var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-download"},[_c('input',{staticClass:"theme-download__input",class:{ 'theme-download__input--white': _vm.white },attrs:{"type":"file","name":_vm.name,"accept":"application/pdf, image/*"}}),_vm._v(" "),_c('span',{staticClass:"icon-upload theme-download__icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }